import axiosInstance from "../../utils/axios_instance";

export async function rechargeData(payload) {
    // const {setShowBIll} = useContext(KycContext)
    console.log("buying data");
   
    let data = "";
    let error = "";
  
    try {
      await axiosInstance.post("/business/bill/payment", payload).then((resp) => {
        data = resp.data.data; 
      });
    } catch (err) {
      error= err;
    }
  
    return {data,error}
  }